import { Outlet, useNavigate, useSearchParams, useLocation } from "react-router-dom";

import { ReactQueryDevtools } from "@tanstack/react-query-devtools";
import {
  QueryCache,
  QueryClient,
  QueryClientProvider,
} from "@tanstack/react-query";
import { AxiosError } from "axios";

import { useAuthStore } from "../stores/authStore";
import { useEffect } from "react";
import { setLocalStorage } from "../lib/localStores";

function RootLayout() {
  const { auth } = useAuthStore();
  const [searchParams] = useSearchParams();

  const navigate = useNavigate();
  const location = useLocation();
  const queryClient = new QueryClient({
    defaultOptions: {
      queries: {
        retry: (failureCount, error) => {
          // eslint-disable-next-line no-console

          if (failureCount > 3) return false;

          return !(
            error instanceof AxiosError &&
            [401, 403].includes(error.response?.status ?? 0)
          );
        },

        staleTime: 0, // Los datos se consideran obsoletos inmediatamente
        cacheTime: 5 * 60 * 1000, // 5 minutos en caché
        refetchOnWindowFocus: true,
        refetchOnReconnect: true,
      },
      mutations: {
        onError: (error) => {
          if (error instanceof AxiosError) {
            if (error.response?.status === 304) {
            }
          }
        },
      },
    },
    queryCache: new QueryCache({
      onError: (error) => {
        if (error instanceof AxiosError) {
          if (error.response?.status === 401) {
            auth.reset();
            navigate("/sign-in");
          }

          if (error.response?.status === 500) {
          }
          if (error.response?.status === 403) {
            // router.navigate("/forbidden", { replace: true });
          }
        }
      },
    }),
  });

  useEffect(() => {
    if (window.dataLayer) {
      window.dataLayer.push({
        event: 'pageview', 
        pagePath: location.pathname + location.search,
      });
    }
  }, [location]);

  useEffect(() => {
    if (!!searchParams.get("sponsor")) {
      setLocalStorage("sponsor", searchParams.get("sponsor"));
    }
  }, [searchParams.get("sponsor")]);
  return (
    <QueryClientProvider client={queryClient}>
      {/*   <GoogleTranslate />
      <GoogleTranslateWatcher /> */}
      <Outlet />

      {process.env.NODE_ENV === "development" && (
        <ReactQueryDevtools initialIsOpen={false} />
      )}
    </QueryClientProvider>
  );
}

export default RootLayout;
